import React, { useState } from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const ForgotPassword = ({ extraClass, forgotStyle }) => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        setMessage('');
        setError('');

        try {
            const response = await fetch(
                'https://api.passionateworlduniversity.com/api/customer/forgot-password',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ email }),
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Something went wrong');
            }

            setMessage(data.message || 'Reset link sent to your email.');
            setEmail('');
        } catch (err) {
            setError(err.message || 'Failed to send reset link');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={`newsletter-area ${forgotStyle}`}>
            <div className="container">
                <div className={`row row--0 newsletter-wrapper align-items-center ${extraClass}`}>
                    <div className="col-lg-4">
                        <div className="newsletter-section-title">
                            <h3 className="title">Forgot Your Password?</h3>
                            <p className="description">
                                Enter your email address to reset your password.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-8">
                        <form
                            className="rn-newsletter mt_md--20 mt_sm--20"
                            onSubmit={handleSubmit}
                        >
                            <div className="form-group">
                                <input
                                    type="email"
                                    placeholder="Email Address"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <button className="btn-default" disabled={loading}>
                                    {loading ? 'Sending...' : 'Send Reset Link'}
                                </button>
                            </div>

                            {message && (
                                <p className="text-success mt--10">{message}</p>
                            )}

                            {error && (
                                <p className="text-danger mt--10">{error}</p>
                            )}

                            <div className="form-group mt--10">
                                <p className="description mb--0">
                                    Remember your password?{' '}
                                    <Link to="/login" className="text-link">
                                        Back to Login
                                    </Link>
                                </p>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
